<div class="title-wrapper mb-16">
  <h3 class="title s-16 mb-16">Assessment Rating</h3>
  <p class="text s-16">
    Score: {{ assessmentData?.reviewScoreType?.reviewScore }}.
    {{ assessmentData?.reviewScoreType?.reviewText }}
  </p>
</div>
<app-correction-needed-form
  [fidelityData]="fidelityData"
  [fidelityFormData]="assessmentData"
  (formValueChange)="formValueChange.emit($event)"></app-correction-needed-form>
